import { AxiosPromise } from 'axios'
import { PaymentGetDataBase } from 'types/api/v1/payment.type'

import OrbitApiV1 from '.'

class PaymentAPI {
  // TODO: Change to AxiosPromise
  static makePayment(paymentBody) {
    return OrbitApiV1.httpPost(`/payment`, {}, paymentBody)
  }

  // TODO: Change to AxiosPromise
  static createPayInt(paymentBody) {
    return OrbitApiV1.httpPost(`/payment/create-intent`, {}, paymentBody)
  }

  static getAllIntents(): AxiosPromise<PaymentGetDataBase[]> {
    return OrbitApiV1.httpGet('/payment/retrieve-intent')
  }

  static updateIntent(payIntentObj: {
    payIntentId: string
    paymentStatus: string
  }): AxiosPromise<PaymentGetDataBase[]> {
    return OrbitApiV1.httpPut(
      `/payment/update-intent/${payIntentObj.payIntentId}`,
      {},
      { paymentStatus: payIntentObj.paymentStatus }
    )
  }
}

export default PaymentAPI
